import { START_SESSION_DONE } from './actionTypes';
export const doneStartingSession = (data) => ({
    type: START_SESSION_DONE,
    data
});
export const doneClosingSession = (data) => ({
    type: 'CLOSING_SESSION_DONE',
    data
});
//# sourceMappingURL=actionCreators.js.map